import { Route } from "react-router-dom";
import { ProtectedRoute } from "../../routers/protected-route";
import { QrCodes } from "./pages";

export const QrCodesRouter = [
  <Route
    path="/qr-codes"
    element={
      <ProtectedRoute roles={["Any"]}>
        <QrCodes />
      </ProtectedRoute>
    }
  />,
];
